import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ZapIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME, PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  const y = reduceMotion ? 0 : 14;
  return <AnimatePresence data-id="element-139" data-mp="18rndy09np3an">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-[14.5rem] overflow-hidden rounded-lg border-2 border-signal bg-navy shadow-xl shadow-signal/30 ring-2 ring-gold sm:w-[17rem]" aria-live="polite" data-id="element-140" data-mp="1zs4lva6sk7rp">
          <div className="flex items-center gap-1.5 bg-gold px-2 py-1" data-id="element-141" data-mp="2ngnvbt1kuqld">
            <ZapIcon className="h-3.5 w-3.5 text-navy" strokeWidth={2.5} aria-hidden="true" data-id="element-142" data-mp="2nj08zu0ayesm" />
            <p className="font-display text-[0.56rem] font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-143" data-mp="2sefo0pa1qgqm">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-navy/70 transition-colors duration-150 ease-out hover:text-navy" data-id="element-144" data-mp="y3kdvij7qtlq">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-145" data-mp="q1tbmkjgoeym" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block px-2 py-1.5" data-id="element-146" data-mp="14ykdr1kis4rx">
            <p className="text-[0.72rem] font-bold leading-tight text-white" data-id="element-147" data-mp="14wr37b6sd0en">
              {sale.name} just bought <span className="text-signal" data-id="element-148" data-mp="1023no1trfgc7">{PRODUCT_NAME}</span>
            </p>
            <p className="mt-0.5 text-[0.62rem] font-semibold text-white/70" data-id="element-149" data-mp="1dxp95z0sbhzv">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}